import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bottom-sort",
  "use": "icon-bottom-sort-usage",
  "viewBox": "0 0 2223 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 2223 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-bottom-sort\"><defs><style type=\"text/css\"></style></defs><path d=\"M1901.431335-0.18006L1110.608757 832.236328 324.107614-0.18006h-324.107614L976.644276 1022.739582h272.250396l972.322842-1022.919642h-319.786179z\" p-id=\"3162\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol